export default {
  privateSubtitle: 'Deseja enviar convites para responderem essa atividade?',
  publicSubtitle: 'Compartilhe esse link com quem você deseja que responda essa atividade',
  cancel: 'Faço isso depois',
  sendForm: 'Enviar atividade',
  shareLink: 'Link de compartilhamento'
}
